export default __webpack_public_path__ + "static/media/Ff.222f9fa4.wav";